module.exports = __webpack_public_path__ + "img/right-2.575410c0.jpg";